<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="flex-grow">
                <div style="display: inline-block" class="vx-col md:w-1/4 sm:w-auto mr-6">
                    <label class="vs-input--label">{{this.$t('equipment.branch')}}</label>
                    <v-select class="" v-model="selectedOrganizationBranch" :clearable="false"
                              :options="organizationBranchOptions">
                        <span slot="no-options"> {{$t('menuOrganization.emptyList')}} </span>
                    </v-select>
                </div>
                <div style="display:inline-block" class="vx-col md:w-1/4 sm:w-auto ml-6">
                    <label class="vs-input--label">{{this.$t('equipment.item')}}</label>
                    <v-select class="" v-model="selectedDevice" :clearable="false"
                              :options="deviceOptions">
                        <span slot="no-options"> {{$t('menuOrganization.emptyList')}} </span>
                    </v-select>
                </div>
            </div>
            <div class="flex flex-wrap items-center mt-5">
                <div class="flex-grow">
                    <div style="display:inline-block">
                        <vs-button
                            @click="addEquipment"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-settings">
                            {{this.$t('equipment.addEquipment')}}
                        </vs-button>
                    </div>
                    <div style="display:inline-block" class="ml-4">
                        <vs-button
                            @click="assignEquipment"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-settings">
                            {{this.$t('equipment.supplies')}}
                        </vs-button>
                    </div>

                </div>

                <!-- ITEMS PER PAGE -->
                <Pagination
                    :itemList="deviceData"
                    :currentPage="currentPage"
                    :paginationPageSize="paginationPageSize"
                    :gridApi="gridApi"
                />

                <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                          v-model="searchQuery"
                          @input="updateSearchQuery" :placeholder="$t('button.search')"/>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         :components="components"
                         :gridOptions="gridOptions"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="deviceData"
                         :localeText="{noRowsToShow: this.$t('menuCamera.noRowsToShow')} "
                         :animateRows="true"
                         :pagination="true"
                         :paginationPageSize="paginationPageSize"
                         :onGridReady="onGridReady"
                         :suppressPaginationPanel="true">
            </ag-grid-vue>

            <vs-pagination
                :total="totalPages"
                :max="maxPageNumbers"
                v-model="currentPage"/>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from "./cell-renderer/AssignTableCellRendererActions.vue"
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import Pagination from "../../ui-elements/Pagination.vue"

export default {
    components: {
        AgGridVue,
        vSelect,
        // Cell Renderer
        CellRendererActions,
        Datepicker,
        Pagination
    },
    data() {
        return {
            searchQuery: "",
            maxPageNumbers: 7,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('equipment.device'),
                    field: 'displayDevice',
                    width: 200
                },
                {
                    headerName: this.$t('equipment.recipient'),
                    field: 'displayEmployee',
                    width: 200,
                },
                {
                    headerName: this.$t('equipment.time'),
                    field: 'displayCreatedAt',
                    width: 150,
                },
                {
                    headerName: this.$t('equipment.count'),
                    field: 'quantity',
                    width: 100,
                },
                {
                    headerName: this.$t('equipment.reason'),
                    field: 'metadata',
                    width: 150,
                },
                {
                    headerName: this.$t('equipment.actions'),
                    field: 'actions',
                    width: 100,
                    cellRendererFramework: 'CellRendererActions',
                },
            ],
            // Cell Renderer Components
            components: {
                CellRendererActions,
            },
            deviceData: [],
            organizationBranchOptions: [],
            deviceOptions: [],
            selectedOrganizationBranchValue: null,
            selectedDeviceValue: null,
        }
    },
    created() {
        this.initScreen()
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateAssignedDevice'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('UPDATE_ASSIGNED_DEVICE', false);
            }
        }
    },
    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize();
            else return 20
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages();
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1)
            }
        },
        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue),
                    value: this.selectedOrganizationBranchValue
                }
            },
            set(obj) {
                this.selectedOrganizationBranchValue = obj.value
                this.loadDevice()
            }
        },

        selectedDevice: {
            get() {
                return {
                    label: this.deviceString(this.selectedDeviceValue),
                    value: this.selectedDeviceValue
                }
            },
            set(obj) {
                this.selectedDeviceValue = obj.value
                this.loadAssignedDevice()
            }
        }
    },
    methods: {
        updateSearchQuery(val) {
            this.gridApi.setGridOption('quickFilterText', val);
        },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || this.$t('menuIntrusion.undefined');
        },
        deviceString(id) {
            let device = this.deviceOptions.find(x => x.value === id);
            return (device && device.label) || this.$t('menuIntrusion.undefined');
        },
        addEquipment() {
            this.$router.push(`/user/add-equipment?branch_id=${this.selectedOrganizationBranchValue}`).catch(() => {
            });
        },
        assignEquipment() {
            this.$router.push(`/user/assign-equipment?branch_id=${this.selectedOrganizationBranchValue}`).catch(() => {
            });
        },
        onGridReady() {
            if (this.$store.state.windowWidth <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
            if (branchList.length === 0) {
                return this.$vs.notify({
                    text: this.$t('menuIntrusion.noBranch'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.map(item => {
                return {value: item.id, label: item.organizationBranchName}
            });
            let branchId = this.$route.query.branch_id;
            let index = 0;
            if (branchId) {
                index = this.organizationBranchOptions.findIndex(item => item.value == branchId)
            }
            this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];

        },
        loadDevice() {
            if (!this.selectedOrganizationBranchValue) return;
            let searchInfo = {
                deviceType: 1,
                organizationBranchId: this.selectedOrganizationBranchValue
            }
            this.$vs.loading();
            this.$crm.post('/device/find-by-condition', searchInfo).then((response) => {
                this.deviceOptions = response.data.map(item => {
                    return {
                        value: item.id,
                        label: item.type + " " + item.model + (item.serialNumber ? " - " + item.serialNumber : "")
                    }
                });
                this.deviceOptions.unshift({value: null, label: this.$t('equipment.all')})
                let deviceId = this.$route.query.id;
                let index = 0;
                if (deviceId) {
                    index = this.deviceOptions.findIndex(item => item.value == deviceId)
                }
                this.selectedDevice = this.deviceOptions[index > -1 ? index : 0];
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: this.$t('equipment.err'),
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        loadAssignedDevice() {
            if (!this.selectedOrganizationBranchValue) return;
            let searchInfo = {
                deviceType: 1,
                organizationBranchId: this.selectedOrganizationBranchValue,
                deviceId: this.selectedDeviceValue
            }
            this.$vs.loading();
            this.$crm.post('/device/find-assigned-device', searchInfo).then((response) => {
                this.deviceData = response.data.map(item => {
                    item.displayDevice = item.type + " " + item.brand + " " + item.model
                    item.displayEmployee = item.employeeId ? item.employeeCode + " - " + item.fullName : "";
                    item.displayCreatedAt = item.assignDate ? moment(item.assignDate).format("DD/MM/YYYY") : "";
                    return item;
                }).filter(item => item.quantity > 0);
                this.$vs.loading.close();
                setTimeout(() => {
                    if (this.$store.state.windowWidth > 1024) {
                        this.gridApi.sizeColumnsToFit();
                    }
                }, 100);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: this.$t('equipment.err'),
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style scoped>

</style>
